import { default as React, useEffect, useState } from 'react'
import { Paper } from '@mui/material'
import ConfirmDialog from '../form/ConfirmDialog'
import Page from '../layout/Page'
import TabPanel from '../form/TabPanel'
import { useParams, useLocation, useNavigate, useBlocker, useSearchParams } from 'react-router-dom'
import TargetFacetsAccordion from './TargetFacetsAccordion'
import TargetPeriodsList from './TargetPeriodsList'

export default function TargetManagementPage(props = {}) {
  const navigate = useNavigate()
  const params = useParams()
  const location = useLocation()
  const [isLoading, setIsLoading] = useState(true)
  const [confirmDialog, setConfirmDialog] = useState(false)

  const breadcrumb = <div><span>Ownership Target Management</span></div>

  const TabbedViews = {
    TARGET_PERIODS: 'target_periods',
    TARGET_FACETS: 'target_facets',
  }
  const [searchParams, setSearchParams] = useSearchParams({ view: TabbedViews.TARGET_PERIODS})
  const [currentTab, setCurrentTab] = useState( searchParams?.get('view') ?? TabbedViews.TARGET_PERIODS)

  const startLoading = () => {
    setIsLoading(true)
  }

  const stopLoading = () => {
    setIsLoading(false)
  }

  const initializePage = async () => {
    startLoading()
    // 
    stopLoading()
  }

  useEffect(() => {
    initializePage()
  }, [])

  const tabs = [
    { 
      key: TabbedViews.TARGET_PERIODS,
      label: 'Target Periods', 
      title: 'Manage Periods for Targets',
      el: <TargetPeriodsList />
    },
    { 
      key: TabbedViews.TARGET_FACETS,
      label: 'Target Facets', 
      title: 'Manage Facets and Targets',
      el: <TargetFacetsAccordion />
    }
  ]

  const onTabChange = (tabIndex) => {
    const viewKey = tabs[tabIndex].key
    setSearchParams({view: viewKey})
    setCurrentTab(viewKey)
  }

  return (
    <Page {...props} breadcrumb={breadcrumb} isLoading={isLoading}>
      {/* <ConfirmDialog title="Discard all changes?" text="You will not be able to recover your work." open={confirmDialog} hideDialog={handleRemain} handleConfirm={handleDiscard} yesLabel="Discard" noLabel="Stay on Page" /> */}

      <Paper
        component="form"
        sx={{ backgroundColor: 'transparent', p: '0 0 3em 0', border: 'none', boxShadow: 'none', display: 'flex', flexDirection: 'column', flexWrap: 'wrap', margin: '1em auto' }}
      >
        <TabPanel panelId='targetMgt' key='targetMgt' tabs={tabs} tabStyle={{ textTransform: 'none', minHeight: 'unset'}}
                  defaultTab={Math.max(tabs.findIndex( v => v.key === currentTab), 0)}
                  onTabChange={(idx) => onTabChange(idx)}
        />
      </Paper>
    </Page>
  )
}